import { Box, Grid } from "@mui/material";
import React, { useEffect } from "react";
import OrderCard from "./OrderCard";
import { useDispatch, useSelector } from "react-redux";
import { getOrderHistory } from "../../../Redux/Customers/Order/Action";
import BackdropComponent from "../BackDrop/Backdrop";

const Order = () => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { order } = useSelector((store) => store);
  const { auth } = useSelector((store) => store);

  console.log("Order Data:", order?.orders);

  useEffect(() => {
    dispatch(getOrderHistory({ jwt }));
  }, [jwt]);

  return (
    <Box className="px-10" style={{ marginBottom: "20px" }}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Box className="space-y-5">
            {order.orders?.length > 0 &&
              order.orders.map((orderItem) =>
                orderItem?.orderItems?.map((item) => (
                  <OrderCard
                    key={item._id}
                    item={item}
                    order={orderItem}
                  />
                ))
              )}
          </Box>
        </Grid>
      </Grid>

      <BackdropComponent open={order.loading} />
    </Box>
  );
};

export default Order;
